import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '../../utils/cn';

const labelVariants = cva(
  'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
);

interface LabelProps
  extends
    React.LabelHTMLAttributes<HTMLLabelElement>,
    VariantProps<typeof labelVariants> {}

function Label({
  className,
  ref,
  ...props
}: LabelProps & { ref?: React.Ref<HTMLLabelElement> }) {
  return (
    <label className={cn(labelVariants(), className)} ref={ref} {...props} />
  );
}

export { Label, labelVariants };
export type { LabelProps };
